import { useEffect } from "react";
import useHistory from "routing/useHistory";
import WorkspaceV2Routes from "./Routes";
const WorkspaceV2InputConfiguration = ({
  url = WorkspaceV2Routes.INTEGRATIONS.WorkspaceV2.ACTIVITYAPI.index
}) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default WorkspaceV2InputConfiguration;
